import { render, staticRenderFns } from "./ReviewHome.vue?vue&type=template&id=2616e9f8&"
import script from "./ReviewHome.vue?vue&type=script&lang=ts&"
export * from "./ReviewHome.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewHome.vue?vue&type=style&index=0&id=2616e9f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports